import { Button, Form, Input, message, Typography } from "antd";
import { useFormik } from "formik";
import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import * as yup from "yup";
import { RequestDemo, requestDemo } from "../../actions/auth/auth";

const { Text, Title } = Typography;

message.config({
  maxCount: 3,
});

const ValidationSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  phone_no: yup
    .string()
    .required("Mobile is required")
    .length(10, "Mobile must be 10 digits"),
  work_email: yup.string().email().required("Work email is required"),
  message: yup.string().required("Message is required"),
  company_name: yup.string().required("Company is required"),
});

const RegisterForDemo = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const req_demo = useSelector((state) => state.auth.requestDemo);
  const formik = useFormik({
    initialValues: {
      name: "",
      phone_no: "",
      work_email: "",
      message: "",
      company_name: "",
    },
    onSubmit: (vals) => {
      dispatch(requestDemo(vals));
    },
    validationSchema: ValidationSchema,
    validateOnMount: false,
    validateOnChange: false,
  });

  useEffect(() => {
    if (req_demo?.data?.status) {
      formik.resetForm();
      dispatch({
        type: RequestDemo.RESET,
      });
    }
    if (req_demo?.data?.status === false) {
      dispatch({
        type: RequestDemo.RESET,
      });
    }
    // eslint-disable-next-line
  }, [req_demo]);

  return (
    <div className="reset-form">
      <div className="head-sec">
        <Title level={3} className="mt2" style={{ color: "#fff" }}>
          Request for demo
        </Title>
      </div>
      <Form onFinish={formik.handleSubmit} layout="vertical">
        <Form.Item
          label={<span style={{ color: "#fff" }}>Name</span>}
          help={formik.errors.name}
          validateStatus={
            formik.errors.name && formik.touched.name ? "error" : "success"
          }
          required
        >
          <Input
            placeholder="Enter name"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
          />
        </Form.Item>
        <Form.Item
          label={<span style={{ color: "#fff" }}>Mobile</span>}
          help={formik.errors.phone_no}
          validateStatus={
            formik.errors.phone_no && formik.touched.phone_no
              ? "error"
              : "success"
          }
          required
        >
          <Input
            placeholder="Enter phone"
            name="phone_no"
            value={formik.values.phone_no}
            onChange={formik.handleChange}
          />
        </Form.Item>
        <Form.Item
          label={<span style={{ color: "#fff" }}>Work email</span>}
          help={formik.errors.work_email}
          validateStatus={
            formik.errors.work_email && formik.touched.work_email
              ? "error"
              : "success"
          }
          required
        >
          <Input
            placeholder="Enter work email"
            name="work_email"
            value={formik.values.work_email}
            onChange={formik.handleChange}
          />
        </Form.Item>
        <Form.Item
          label={<span style={{ color: "#fff" }}>Company</span>}
          help={formik.errors.company_name}
          validateStatus={
            formik.errors.company_name && formik.touched.company_name
              ? "error"
              : "success"
          }
          required
        >
          <Input
            placeholder="Enter company name"
            name="company_name"
            value={formik.values.company_name}
            onChange={formik.handleChange}
          />
        </Form.Item>
        <Form.Item
          label={<span style={{ color: "#fff" }}>Message</span>}
          help={formik.errors.message}
          validateStatus={
            formik.errors.message && formik.touched.message
              ? "error"
              : "success"
          }
          required
        >
          <Input
            placeholder="Enter message"
            name="message"
            value={formik.values.message}
            onChange={formik.handleChange}
          />
        </Form.Item>

        <div className="mt1">
          <Text className="text-dim" style={{ color: "#fff" }}>
            By clicking on “Book your demo” you agree to be contacted by Paycraft to receive information about the Demo.
          </Text>
        </div>
        <Button
          htmlType="submit"
          className="primaryButton mt2"
          disabled={req_demo?.loading}
        >
          {req_demo?.loading ? (
            <ClipLoader loading={req_demo?.loading} size={10} />
          ) : (
            "Book your demo"
          )}
        </Button>
      </Form>

      <div className="mt2 flex-center">
        <span
          className="text-dim footer-note"
          style={{ color: "var(--text-primary)" }}
        >
          Have an account ? Click here to{" "}
          <b
            className="cursor"
            onClick={() => {
              history.push("/");
            }}
            style={{ color: "var(--bg-orange-light)" }}
          >
            Login
          </b>
        </span>
      </div>
      {/* <div className="mt1 flex-center">
        <span className="text-dim footer-note" style={{ textAlign: "center" }}>
          Help and Support{" "}, Phone: <a href="tel:+91 7400088941">+91 7400088941</a>{" "},
          Email: <a href="mailto:customercare@paycraftsol.com">customercare@paycraftsol.com</a>
        </span>
      </div> */}
    </div>
  );
};

export default RegisterForDemo;
